export enum HEALTH_STATUS {
  OK = 'OK',
  DOWN = 'DOWN'
}
